(function () {
  const CUSTOMER_ID = window.CUSTOMER_ID || null;
  const STORAGE_KEY = CUSTOMER_ID
  ? `wishlist_products_${CUSTOMER_ID}`
  : 'wishlist_products_guest';
  // const CUSTOMER_WISHLIST = window.CUSTOMER_WISHLIST || '';

  // Get wishlist as array of product handles
  function getWishlist() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  }

  // Save wishlist
  function saveWishlist(items) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      updateWishlistCount();
  }

  // Toggle product in wishlist
  function toggleWishlist(handle, button) {
    let wishlist = getWishlist();
    if (wishlist.includes(handle)) {
      wishlist = wishlist.filter(h => h !== handle);
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    } else {
      wishlist.push(handle);
      button.classList.add('is-active');
      button.setAttribute('aria-pressed', 'true');
    }
    saveWishlist(wishlist);
  }

  // Initialize wishlist buttons
  function initButtons() {
    const wishlist = getWishlist();
    document.querySelectorAll('[data-wishlist-button]').forEach(btn => {
      if (wishlist.includes(btn.dataset.productHandle)) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      }
    });
  }

  // Update wishlist count in header
  function updateWishlistCount() {
    const count = getWishlist().length;
    const el = document.getElementById('wishlist-count');
    if (el) el.textContent = count;
  }

  // Render wishlist products on page
  async function renderWishlist() {
    const container = document.getElementById('wishlist-products');
    if (!container) return;

    const wishlist = getWishlist();
    if (!wishlist.length) {
      container.innerHTML = '<p>Your wishlist is empty.</p>';
      return;
    }

    const htmlArr = await Promise.all(
      wishlist.map(async handle => {
        try {
          const res = await fetch(`/products/${handle}.js`);
          const product = await res.json();
          const price = product.price ? `₹ ${Math.round(product.price / 100)}` : '';
          const image = product.images[0] || '';

          const addedDate = new Date().toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric'
          });

          return `
            <div class="wishlist-card"
              data-handle="${handle}"
              data-proid="${product.id}"
              data-varid="${product.variants[0].id}">

              <div class="wishlist__product">
                <div class="wishlist__product-img">

                  <a href="${product.url}" class="wishlist-product__image">
                    <img
                      src="${product.images[0]}"
                      alt="${product.title}"
                      class="img-list">
                  </a>

                  <p class="item__delete grid__view">
                    <a href="#"
                      class="icon-wishlist-bin wishlist-remove"
                      data-handle="${handle}"
                      style="color:#494B4D;"></a>
                  </p>

                </div>

                <div class="wishlist__product-content">
                  <p class="wishlist-product__title">${product.title}</p>
                  <p class="vendor">${product.vendor || 'GemsRoot'}</p>

                  <p class="wishlist-price">
                    <span class="money">₹ ${Math.round(product.price / 100)}</span>
                  </p>

                  <p class="varient"></p>
                  <div class="variants"></div>
                </div>
              </div>

              <div class="wishlist-status">
                <button
                  class="wishlist-btn wishlistBtnStyle move-to-cart"
                  data-handle="${handle}"
                  data-variant-id="${product.variants[0].id}"
                  style="background:#494B4D;border:1px solid #494B4D;color:#fff;">
                  Move to cart
                </button>

                <p class="added_date grid__view">
                  Added on ${addedDate}
                </p>
              </div>
            </div>
          `;

        } catch (err) {
          console.error(err);
          return '';
        }
      })
    );

    container.innerHTML = htmlArr.join('');

  }

  document.addEventListener('click', async function (e) {

    /* OPEN CONFIRM MODAL */
    const deleteBtn = e.target.closest('.wishlist-remove');
    if (deleteBtn) {
      e.preventDefault();
      openWishlistConfirm(deleteBtn.dataset.handle);
      return;
    }

    /* CONFIRM YES */
    if (e.target.classList.contains('wishlist-confirm-yes')) {
      if (wishlistDeleteHandle) {
        saveWishlist(getWishlist().filter(h => h !== wishlistDeleteHandle));
        renderWishlist();
      }
      closeWishlistConfirm();
      return;
    }

    /* CONFIRM NO / CLOSE */
    if (
      e.target.classList.contains('wishlist-confirm-no') ||
      e.target.classList.contains('wishlist-confirm-close')
    ) {
      closeWishlistConfirm();
      return;
    }

    /* MOVE TO CART */
    const moveBtn = e.target.closest('.move-to-cart');
    if (moveBtn) {
      e.preventDefault();
      const handle = moveBtn.dataset.handle;
      const variantId = moveBtn.dataset.variantId;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        saveWishlist(getWishlist().filter(h => h !== handle));
        renderWishlist();
      } catch (err) {
        console.error(err);
        alert('Unable to add to cart');
      }
    }

  });

  // Event delegation for product page/collection buttons
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishlist-button]');
    if (!btn) return;
    e.preventDefault();
    toggleWishlist(btn.dataset.productHandle, btn);
  });

  let wishlistDeleteHandle = null;

  function openWishlistConfirm(handle) {
    wishlistDeleteHandle = handle;
    document.getElementById('wishlist-confirm-modal').style.display = 'flex';
  }

  function closeWishlistConfirm() {
    wishlistDeleteHandle = null;
    document.getElementById('wishlist-confirm-modal').style.display = 'none';
  }

  document.addEventListener('DOMContentLoaded', function () {
    initButtons();
    updateWishlistCount();
    renderWishlist();
  });
})();
